import { OverlayTrigger, Tooltip } from "react-bootstrap"

const HoverTooltip = ({ children, text, id, style }: any) => {
  return (
    <OverlayTrigger overlay={<Tooltip style={style} id={id}>{text}</Tooltip>}>
      {children}
    </OverlayTrigger>
  )
}

export default HoverTooltip
